<script setup lang="ts">
import { dayjs } from "element-plus";
import { zhCn } from "element-plus/es/locales.mjs";

onMounted(() => {
  document.body.addEventListener("plugin_web_update_notice", () => {
    window.location.reload();
  });
});

const s = "2020-10-39";
const da = dayjs(s, DATE_FORMAT, true);
console.log("时间是否有效: ", da.isValid());
</script>

<template>
  <el-config-provider :locale="zhCn">
    <RouterView></RouterView>
  </el-config-provider>
</template>
